/**
 * Language Provider Helper Component
 * Used to Display Localised Strings
 */
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

// Injected message
// const InjectMassage = props => <FormattedMessage {...props} />;

const FormattedMessageWithClass = props => (
  <FormattedMessage {...props}>
    {txt => (
      <span style={props.style} className={props.className}>
        {txt}
      </span>
    )}
  </FormattedMessage>
);
export default injectIntl(FormattedMessageWithClass, {
  withRef: false
});
